import { BaseEnvService } from '@aipb/gulliver/env/util';
import { baseUrl, pathWithParams, stringifyQueryParams } from '@aipb/shared/util/routing';
import { inject } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

export abstract class BaseRouting {
  static dashboardPath = 'dashboard';
  static dashboardDefaultPath = '';
  private router = inject(Router);
  private transloco = inject(TranslocoService);
  private _dashboardDefault: string[] = [BaseRouting.dashboardPath];

  protected constructor(private basePath: string[], private env: BaseEnvService<any, any>) {}

  public dashboardDefault(configId: string = this.getConfigId()): void {
    this.nav(this._dashboardDefault, {
      configId
    });
  }

  public dashboardDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._dashboardDefault, {
      configId
    });
  }

  public dashboardDefaultAbsUrl(configId: string = this.getConfigId()): string {
    return this.absUrl(this._dashboardDefault, {
      configId
    });
  }

  protected getConfigId(): string {
    return this.env.activeConfigId;
  }

  protected nav(path: string[] = [], params: Record<any, any> = {}, extras?: NavigationExtras): void {
    if (!extras) {
      extras = {
        queryParams: {
          lang: this.transloco.getActiveLang()
        }
      };
    } else {
      extras = {
        ...extras,
        queryParams: {
          ...(extras.queryParams || {}),
          lang: extras?.queryParams['lang'] || this.transloco.getActiveLang()
        }
      };
    }

    this.route(this.buildPath(path, params), extras);
  }

  protected absUrl(path: string[] = [], params: Record<any, any> = {}, queryParams?: Record<any, any>): string {
    if (!queryParams) {
      queryParams = {};
    }

    if (!('lang' in queryParams)) {
      queryParams['lang'] = this.transloco.getActiveLang();
    }
    return `${baseUrl()}${this.buildPath(path, params, true).join('/')}${stringifyQueryParams(queryParams)}`;
  }

  protected routeUrl(path: string[] = [], params: Record<any, any> = {}): string {
    return this.buildPath(path, params).join('/');
  }

  private route(path: string[], extras?: NavigationExtras): void {
    this.router.navigate(path, extras);
  }

  private buildPath(path: string[], params?: Record<any, any>, shouldEncode = false): string[] {
    return [
      ...pathWithParams(this.basePath, params),
      ...pathWithParams([].concat(...path.map((p) => p.split('/'))), params, shouldEncode)
    ];
  }
}
